import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { fetchToolByCategory } from "../api/api";

import SearchBar from "../components/SearchBar";
import ToolCard from "../components/ToolCard";
import StickyNavbar from "../components/StickyNavbar";

import CSpinner from '../components/CSpinner';

const CategoryTools = () => {
  const [tools, setTools] = useState([]);
  const [loading, setLoading] = useState(false);

  const [texting, setTexting] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const location = useLocation();
  const { categoryId, categoryName } = location.state || {}; // Get passed value

  const fetchData = async () => {
    try {
      setTexting(true);
      setLoading(true);
      setTools([]);

      const results = await fetchToolByCategory(categoryId);
      
      setTools(Array.isArray(results) ? results : []); 

    } catch (error) {
        console.error('Error submitting review:', error);
        setLoading(false);
    } finally {
      setLoading(false); // Hide spinner and show h1 again
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (

    <div className="min-h-screen bg-gray-100 flex flex-col items-center p-6">
      <StickyNavbar />

      {/* Page Content - Ensure it's not covered by Navbar */}
      <div className="w-full max-w-4xl pt-20">
        <h1 className="text-3xl font-bold mb-6 text-center">{categoryName}' Tools</h1>

        <div className="flex justify-center items-center">
          {loading && <CSpinner /> }
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
          {tools.map((tool) => (
            <ToolCard key={tool._id} tool={tool} />
          ))}
        </div>

      </div> 

      {/* Footer with Search Bar */}
      {/*<div className="w-full mt-auto py-6 flex justify-center">
        <SearchBar onSearch={handleSearch} />
      </div>*/}
    </div>
  );
};

export default CategoryTools;
